module.exports = __webpack_public_path__ + "img/respect.e2f579d1.svg";